import BlockType from '../../../models/BlockType';

interface Props {
  blockType: BlockType
  active: boolean
  onMenuItemSelect: (index: number) => void
}

const AtomicBlockItem = (props: Props) => {
  const { blockType, onMenuItemSelect, active } = props;

  const title = BlockType.describe(blockType);

  return (
<div className={`card blockitem ${active ? 'active' : ''}`} onClick={() => onMenuItemSelect(blockType)}>
    <div className="card-header d-flex position-relative">
      <div className="block-header">
        <h5 className="block-title">{title}</h5>
        <p className="block-sub-title" />
      </div>
    </div>
    <div className="card-body d-flex">
      <div className="block-image">
        <img src="img/blocks/sample_block.png" alt="" />
      </div>
      <div className="block-btn-bottom-right" />
    </div>
</div>
  );
};

export default AtomicBlockItem;
